import { render, staticRenderFns } from "./authStep.vue?vue&type=template&id=0f3a1924&scoped=true"
import script from "./authStep.vue?vue&type=script&lang=js"
export * from "./authStep.vue?vue&type=script&lang=js"
import style0 from "./authStep.vue?vue&type=style&index=0&id=0f3a1924&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3a1924",
  null
  
)

export default component.exports